export const isEmpty = (val) => {
    if (typeof val === "string") {
        return val.trim().length > 0;
    } else if (Array.isArray(val)) {
        return val.length > 0;
    } else if (typeof val === "object") {
        return Object.entries(val).length > 0;
    }
}